var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"secondary","loading":this.state.loading},domProps:{"textContent":_vm._s(_vm.$tf('sign_in | cryptopro'))},on:{"click":_vm.sign}})}
var staticRenderFns = []

export { render, staticRenderFns }